module.exports = __webpack_public_path__ + "static/homepage-wireframe-m-87545c5e33d2c55923682906d037ef6e.png";